import styled, {
  boxShadows,
  BoxShadows,
  css,
  falconTheme,
  FlattenSimpleInterpolation,
  IFalconTheme,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

export const DiscountBadgeContainer: StyledComponent<'span', IFalconTheme, {}> = styled('span')`
  border-radius: ${Scale.xxs};
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: ${boxShadows[BoxShadows.level1]};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fontFamilyBody.join(',')};
  padding: ${Scale.xs};
`;

DiscountBadgeContainer.defaultProps = { theme: falconTheme };

export const ResponsiveTypographyStyle: FlattenSimpleInterpolation = css`
  text-align: center;
`;
